import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-393701ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sqg-header" }
const _hoisted_2 = { class: "sqg-header__title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-folder-open" }, null, -1))

import {useFoldersStore} from "@/stores/folders";
import {storeToRefs} from "pinia";
import {useUserStore} from "@/stores/user";


export default /*#__PURE__*/_defineComponent({
  props: {
  title: { type: String, default: '' },
  icone: { type: String, default: '' },
  displayCurrentFolder: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props


const foldersStore = useFoldersStore();
const { currentFolder } = storeToRefs(foldersStore);
const userStore = useUserStore();
const { user } = storeToRefs(userStore);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(user).role === 'admin' || _unref(user).role === 'superAdmin')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Administration"))
        : _createCommentVNode("", true),
      _createElementVNode("i", {
        class: _normalizeClass(__props.icone)
      }, null, 2),
      _createElementVNode("div", null, _toDisplayString(__props.title), 1)
    ]),
    (__props.displayCurrentFolder)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "sqg-header__folderName clickable",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/folder/${_unref(user).preferences.currentFolderId}`)))
        }, [
          _hoisted_4,
          _createTextVNode(_toDisplayString(_unref(currentFolder).name), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})